import { translate } from '@/utils/translations'

const WhatIsMarketplaceMessage = () => (
  <div>
    <h3 className='mb-3'>
      {translate('assets.show.what_is_marketplace_title')}
    </h3>
    {translate('assets.show.what_is_marketplace_explanation')}
  </div>
)

export default WhatIsMarketplaceMessage
